export default __webpack_public_path__ + "static/spartan_gris-d2ce4ce911faa86ba7baeb90ec4b45f2.svg";